<div
  class="w-100"
  [ngClass]="{ 'has-header-portal': headerPortal$ | async }"
>
  <!--Desktop-->
  @if (!isMobile()) {
    <div
      class="h-100 d-flex align-items-center"
      [ngClass]="{ 'card p-2': inCard }"
      style="flex-direction: row"
    >
      @if (statusColor) {
        <i
          class="fas fa-circle turbine-status mr-2"
          [ngStyle]="{ color: statusColor | colorStatusCode: 'color' }"
          [ngClass]="{ 'outline-circle': statusColor === 5 }"
        ></i>
      }
      @if (title) {
        <div class="d-flex align-items-center position-relative site-title-actions">
          <div
            [ngStyle]="{ 'margin-left': '0px', 'max-width': '15em', flex: '0 1 auto' }"
            class="adaptable-font-size font-weight-bold text-primary title no-break text-nowrap"
          >
            {{ title }}
          </div>
          <app-site-technology-buttons></app-site-technology-buttons>
        </div>
      }
      <ng-container *ngTemplateOutlet="pages"></ng-container>
    </div>
  }

  <!--Mobile-->
  @if (isMobile()) {
    <div
      class="h-100 d-flex align-items-center"
      [style]="mobileStyle"
    >
      <ng-container *ngTemplateOutlet="mobileNav"></ng-container>
      <ng-template [cdkPortalOutlet]="headerPortal$ | async"></ng-template>
    </div>
  }
</div>

<ng-template #pages>
  <ul
    class="w-100 nav d-flex align-items-center justify-content-center"
    style="flex: 1"
  >
    @for (item of items; track $index) {
      <li class="nav-item mr-3">
        @if (!item.route) {
          <div
            class="item font-weight-bold m-0 navigation-tab adaptable-font-size"
            [class.navigation-active-tab]="item.active"
            (click)="setActive(item, 1)"
          >
            {{ item.name | translate }}
          </div>
        }
        @if (item.route) {
          <div
            class="item font-weight-bold m-0 navigation-tab adaptable-font-size"
            [routerLink]="[item.route]"
            routerLinkActive="active"
          >
            {{ item.name }}
          </div>
        }
      </li>
    }
  </ul>
  <ng-template [cdkPortalOutlet]="headerPortal$ | async"></ng-template>
</ng-template>

<ng-template #mobileNav>
  <div [style.width]="(headerPortal$ | async) ? '60%' : '80%'">
    <mat-tab-group
      [selectedIndex]="activeIndex"
      [mat-stretch-tabs]="false"
      (selectedTabChange)="onMobileTabChange($event)"
      class="mobile-nav-tabs"
    >
      @for (item of items; track $index) {
        <mat-tab [label]="item.name | translate"></mat-tab>
      }
    </mat-tab-group>
  </div>
</ng-template>
